"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importStar(require("react"));

var styled_components_1 = require("styled-components");

var FormFieldContainer_1 = __importDefault(require("../FormFieldContainer/FormFieldContainer"));

var Icon_1 = require("../Icon/Icon");

var Popup_1 = require("../Popup");

var styled_1 = require("../styled");

var styled_2 = require("./styled");

var FormPickerTypeEnum;

(function (FormPickerTypeEnum) {
  FormPickerTypeEnum["singleSelect"] = "singleSelect";
  FormPickerTypeEnum["multiSelect"] = "multiSelect";
})(FormPickerTypeEnum = exports.FormPickerTypeEnum || (exports.FormPickerTypeEnum = {}));

var FormPicker =
/** @class */
function (_super) {
  __extends(FormPicker, _super);

  function FormPicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      menuOptions: []
    };

    _this.generateMenuOptions = function () {
      var _a = _this.props,
          type = _a.type,
          options = _a.options;
      var optionsValues = utilities_1.values(options);
      var popupOptions = optionsValues.map(function (option, idx) {
        var label = option.label;

        var isSelected = _this.isOptionSelected(option);

        var isDisabled = isSelected && type === FormPicker.type.singleSelect;
        return {
          onSelect: _this.onOptionSelect(option),
          render: function render() {
            return react_1.default.createElement(styled_2.OptionContainer, {
              key: idx
            }, react_1.default.createElement(styled_2.OptionText, {
              selected: isSelected
            }, label));
          },
          disabled: isDisabled
        };
      });

      _this.setState({
        menuOptions: popupOptions
      });
    };

    _this.onOptionSelect = function (option) {
      return function () {
        var type = _this.props.type;

        if (type === FormPicker.type.multiSelect) {
          _this.multiSelectOnOptionSelect(option);

          return false;
        }

        _this.singleSelectOnOptionSelect(option);
      };
    };

    _this.getSelectedLabel = function () {
      var type = _this.props.type;

      if (type === FormPicker.type.multiSelect) {
        return _this.getMultiselectLabel();
      }

      return _this.getSingleSelectLabel();
    };

    _this.renderTrigger = function () {
      var theme = _this.props.theme;

      var label = _this.getSelectedLabel();

      return react_1.default.createElement(styled_2.Trigger, null, react_1.default.createElement(styled_2.TriggerTextContainer, null, react_1.default.createElement(styled_2.TriggerText, {
        numberOfLines: 1
      }, label), react_1.default.createElement(Icon_1.Icon, {
        name: 'chevron-down',
        size: Icon_1.IconSizeEnum.small,
        color: theme.colors.gray
      })));
    };

    return _this;
  }

  FormPicker.prototype.componentDidMount = function () {
    this.generateMenuOptions();
  }; // todo handle props.options update - when needed


  FormPicker.prototype.componentDidUpdate = function (prevProps) {
    var prevValue = prevProps.field.value,
        type = prevProps.type;

    if (type === FormPicker.type.singleSelect) {
      this.handleSingleSelectUpdate(prevValue);
      return;
    }

    this.handleMultiSelectUpdate(prevValue);
  };

  FormPicker.prototype.handleSingleSelectUpdate = function (prevValue) {
    var currentValue = this.props.field.value;

    if (prevValue !== currentValue) {
      this.generateMenuOptions();
    }
  };

  FormPicker.prototype.handleMultiSelectUpdate = function (prevValue) {
    var currentValue = this.props.field.value;

    if (prevValue.length !== currentValue.length) {
      this.generateMenuOptions();
    }
  };

  FormPicker.prototype.isOptionSelected = function (option) {
    var _a = this.props,
        type = _a.type,
        selectedValue = _a.field.value;
    var value = option.value;

    if (type === FormPicker.type.singleSelect) {
      return value === selectedValue;
    } // multiselect


    return selectedValue.includes(value);
  };

  FormPicker.prototype.singleSelectOnOptionSelect = function (_a) {
    var value = _a.value;
    var _b = this.props,
        name = _b.field.name,
        setFieldValue = _b.form.setFieldValue;
    setFieldValue(name, value);
  };

  FormPicker.prototype.multiSelectOnOptionSelect = function (_a) {
    var value = _a.value;
    var _b = this.props,
        _c = _b.field,
        name = _c.name,
        currentValue = _c.value,
        setFieldValue = _b.form.setFieldValue; // add or remove selection

    var newValues = this.setMultiSelectNewValue(currentValue, value);
    setFieldValue(name, newValues);
  };

  FormPicker.prototype.setMultiSelectNewValue = function (currentValue, value) {
    if (!currentValue.length) {
      return [value];
    }

    var includes = currentValue.includes(value);

    if (includes) {
      return utilities_1.without(currentValue, value);
    }

    return __spreadArrays(currentValue, [value]);
  };

  FormPicker.prototype.getSingleSelectLabel = function () {
    var _a = this.props,
        options = _a.options,
        value = _a.field.value;
    var option = options[value];

    if (!option) {
      return FormPicker.defaultSelectLabel;
    }

    return option.label;
  };

  FormPicker.prototype.getMultiselectLabel = function () {
    var _a = this.props,
        options = _a.options,
        value = _a.field.value;
    var label = '';

    if (value && value.length === 1) {
      var option = options[value];

      if (!option) {
        return FormPicker.defaultSelectLabel;
      }

      return option.label;
    }

    value.forEach(function (v) {
      var option = options[v];

      if (!option) {
        return;
      }

      label += option.label + ", ";
    });
    return label ? label.trim().slice(0, -1) : FormPicker.defaultSelectLabel;
  };

  FormPicker.prototype.render = function () {
    var _a = this.props,
        disabled = _a.disabled,
        label = _a.label,
        menuOptionTestIdPrefix = _a.menuOptionTestIdPrefix,
        menuName = _a.menuName;
    var menuOptions = this.state.menuOptions;
    return react_1.default.createElement(FormFieldContainer_1.default, null, react_1.default.createElement(styled_1.StyledInputLabel, {
      numberOfLines: 1
    }, label || ''), react_1.default.createElement(Popup_1.Popup, {
      renderer: Popup_1.Popup.Renderers.ContextMenu,
      renderTrigger: this.renderTrigger,
      disabled: disabled,
      options: menuOptions,
      optionsCustomStyles: styled_2.popupOptionsCustomStyles,
      triggerCustomStyles: styled_2.triggerCustomStyles,
      menuOptionTestIdPrefix: menuOptionTestIdPrefix,
      menuName: menuName,
      onMenuRef: this.props.onMenuRef
    }));
  };

  FormPicker.type = FormPickerTypeEnum;
  FormPicker.defaultSelectLabel = 'Select';
  return FormPicker;
}(react_1.Component);

exports.FormPicker = FormPicker;
exports.default = styled_components_1.withTheme(FormPicker);